<template>
    <el-container class="is-vertical">  
        <top-header></top-header>
        <el-main>
            <div class="no-app-list" v-if="show">
                <div class="tip">你当前没有已创建的应用，来创建个新应用吧</div>
                <div class="app-cont" @click="createApp">
                    <div><img src="./Combined Shape.png" alt=""></div>
                    <p>创建新应用</p>
                </div>
            </div>
            <div class="app-list" v-if="!show">
                <h1>亲爱的开发者你好，选择应用进入管理页面，或添加一个全新应用。</h1>
                <ul>
                    <li class="published-item" @click="changeRoute(item.appId, index)" v-for="(item, index) in appList" :key="index">
                        <div class="ding" :class="item.appStatus == 1 ? 'pub' : ''"></div>
                        <div class="published">{{filter.appStatus(item.appStatus)}}</div>
                        <div class="app-img"><img :src="item.appIcon" alt=""></div>
                        <div class="app-name">{{item.appName}}</div>
                        <div class="app-type">应用类型：{{filter.appType(item.appType)}}</div>
                    </li>
                    <li class="insert-item" @click="createApp" v-if="appList.length < 5">
                        <img src="./Combined Shape2.png">
                    </li>
                </ul>
                <div class="tip">*每个账户最多添加5个应用*</div>
            </div>
        </el-main>
    </el-container>
</template>
<script>
import topHeader from '@/components/top-header'
import {http, apiJson, filter} from '@/utils/http'
import { Message } from 'element-ui';
export default {
    data () {
        return {
            appList:[],
            show: true,
            interval: true
        }
    },
    created () {
        let token = localStorage.getItem('token')
        let email = localStorage.getItem('email')
        if(!token && !email){
            this.$router.push("/login")
        }else {
            this.getListApps()
        }
        this.filter = filter
    },
    components:{
        topHeader
    },
    methods: {
        createApp () {
            const count = this.appList.length;
            if(count >=5){
                console.log("应用超过五个了")
            }else if(this.interval) {
                Message.success("正在创建新的应用，请稍等！")
                this.interval = false
                http(apiJson.openparampage).then(res => {
                    if( res.code == 0 && res.data && res.data.appKey) {
                        this.$router.push("/create-app/" + res.data.appKey)
                        setTimeout(() => {
                            this.interval = true
                        }, 10000);
                    }
                })
                
            }else {
                Message.warning('请稍后重试!')
            }
        },
        getListApps () {
            http(apiJson.listApps).then(res => {
                if(res) {
                    if(res.code == 0) {
                        this.appList = res.data
                        this.show = false
                    }else if(res.code == 2) {
                        Message.warning(res.message)
                        this.show = true
                    }else {
                        Message.error('接口错误:' + res.message)
                        this.$router.push("/login")
                    }
                }else {
                        Message.error('接口错误')
                        this.$router.push("/login")
                    }
            }).catch(error => {
                console.log(error)
            })
        },
        changeRoute (appId, i) {
            if(this.interval) {
                this.$router.push("/create-app/" + appId)
            }else {
                Message.warning('请稍后重试')
            }
            
        }
    }
};
</script>
<style lang='scss' scope>
    @import './home.scss';
</style>





// WEBPACK FOOTER //
// src/pages/Home/home.vue